import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import "./Timer.scss";
import { Counter } from "../ScoreBoardItem/Counter/Counter";
import dayjs from "dayjs";
import { TimerContext } from "../../../context/TimerContext";

interface IProps {
    minutes: number
    state: 'running' | 'idle'
    setState: Dispatch<SetStateAction<'running' | 'idle'>>
    onEnd: () => void
}

const alertAtNumberOfSecondsLeft = 30;
export function Timer({ minutes: totalMinutes, state, setState, onEnd }: IProps) {
    const { setTime } = useContext(TimerContext);
    const [endDate, setEndDate] = useState<Date | undefined>(undefined);
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        if (state === 'idle') {
            setEndDate(undefined);
            return;
        }
        setEndDate(dayjs(new Date()).add(totalMinutes, 'minutes').toDate());
    }, [totalMinutes, state]);

    useEffect(() => {
        if (state === 'idle') return;
        if (!endDate) return;

        const now = dayjs();
        const difference = Math.max(0, dayjs(endDate).diff(now, 'milliseconds'));

        if (difference === 0) {
            setState('idle');
            setTimeLeft(difference)
            onEnd();
            return;
        }
        const timeout = setTimeout(() => {
            setTimeLeft(difference)
        }, 1);
        return () => {
            clearTimeout(timeout);
        }
    }, [endDate, timeLeft, state, setState, onEnd]);

    let msLeft = timeLeft;
    const numberOfMinutes = Math.floor( msLeft / (60 * 1000));
    msLeft = msLeft - (numberOfMinutes * 60 * 1000);
    const numberOfSeconds = Math.floor(msLeft / 1000);
    msLeft = msLeft - (numberOfSeconds * 1000);

    const [minutes, seconds, milliseconds] = [numberOfMinutes, numberOfSeconds, msLeft];

    useEffect(() => {
        setTime([minutes, seconds, milliseconds]);
    }, [setTime, minutes, seconds, milliseconds])

    const classes = ['timer-wrapper'];
    if (state === 'running' && timeLeft / 1000 <= alertAtNumberOfSecondsLeft) {
        classes.push('alert');
    }

    return (
        <div className={classes.join(' ')}>
            <Counter value={minutes} minDigits={2} />
            <span>:</span>
            <Counter value={seconds} minDigits={2} />
            <span>:</span>
            <Counter value={milliseconds} minDigits={3} />
        </div>
    )
}
